import {Component, OnInit, Optional} from '@angular/core';
import { Router } from '@angular/router';
import { Project, User } from '../../_models';
import {
  AlertService,
  AuthenticationService,
  ProjectService,
} from '../../_services';
import { LoginHelper, Recurring, StringsHelper } from '../../helpers';
import {DynamicDialogRef} from "primeng/dynamicdialog";

@Component({
    standalone: false,
  selector: 'select-project-control-item',
  templateUrl: 'select-project-control-item.component.html',
  styleUrls: ['./select-project-control-item.component.scss'],
})
export class SelectProjectControlItemComponent implements OnInit {
  projects: Project[] = [];
  currentUser: User;
  recurringList: any;
  rowGroupMetadata: any = {};

  cols: any[] = [
    { 'field': 'controlItem.complianceAreaControlId', 'header': 'Control ID' },
    { 'field': 'controlItem.category', 'header': 'Category' },
    { 'field': 'controlItem.description', 'header': 'Description' },
  ];

  constructor(
    public projectService: ProjectService,
    public router: Router,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public dialogRef: DynamicDialogRef,
  ) {}

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }
    this.recurringList = [];
    for (let i = 0; i <= Recurring.Yearly; i++) {
      this.recurringList[i] = Recurring[i].toString();
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    const prjs: any = this.projectService.getUsersAllProjects(
      this.currentUser.userId
    );

    prjs.subscribe(
      (projects) => {
        this.projects = projects;
      },

      (error) => {
        const errorMessage = 'An error occurred while loading projects.';
        this.alertService.error(errorMessage);
      }
    );
  }

  getControlItems(event) {
    if (
      event.data.projectControlItems &&
      event.data.projectControlItems.length
    ) {
      return event.data.projectControlItems;
    }
    event.data.loading = true;
    this.projectService.getById(event.data.projectId).subscribe((p) => {
      event.data.loading = false;
      event.data.projectControlItems = p.projectControlItems;
      this.updateRowGroupMetaData(event.data.projectId, p.projectControlItems);
    });
  }
  getFullName(user: User) {
    return StringsHelper.getFullName(user);
  }

  selectProjectControlItem(data) {
    data.projectName = this.projects.find(
      (p) => p.projectId == data.projectId
    ).name;
    this.dialogRef.close(data);
  }

  updateRowGroupMetaData(projectId, data) {
    this.rowGroupMetadata[projectId] = {};
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.controlItem.category;
        if (i == 0) {
          this.rowGroupMetadata[projectId][brand] = { index: 0, size: 1 };
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.controlItem.category;
          if (brand === previousRowGroup)
            this.rowGroupMetadata[projectId][brand].size++;
          else this.rowGroupMetadata[projectId][brand] = { index: i, size: 1 };
        }
      }
    }
  }
}
